import React from 'react';
import { Row, Col, ContentContainer } from '@snsw/react-component-library';
import styles from './ContactUsInfo.module.scss';

const ContactUsInfo = (props) => {
  const renderEmail = (email) => {
    if (email.label && email.address) {
      return (
        <div>
          <p className={styles.body}>
            <em>{email.label}</em>
          </p>
          <p className={styles.body}>
            <a href={`mailto:${email.address}`}>{email.address}</a>
          </p>
        </div>
      );
    } else {
      return (
        <p className={styles.body}>
          <a href={`mailto:${email}`}>{email}</a>
        </p>
      );
    }
  };

  const renderWeb = (web) => {
    if (web.label && web.address) {
      return (
        <div>
          <p className={styles.body}>
            <a href={web.address} target={'_blank'}>
              {web.label}
            </a>
          </p>
        </div>
      );
    } else {
      return (
        <p className={styles.body}>
          <a href={web} target={'_blank'}>
            {web}
          </a>
        </p>
      );
    }
  };

  return (
    <div className={`${styles.footerContainer} ${props.className ?? ''}`}>
      <div className={styles.footer}>
        <ContentContainer>
          <Row className={styles.nonMargin}>
            <Col span={3}>
              {props.logo ? <img src={props.logo} alt="NSW Government Logo" className={styles.logo} /> : null}
            </Col>
            <Col span={3}>
              {props.address ? (
                <>
                  <p className={styles.title}>Address</p>
                  <div className={styles.addressCont}>
                    {props.address.map((al) => (
                      <p className={`${!al ? styles.pargraph : ''} ${styles.addressBody}`}>{al}</p>
                    ))}
                  </div>
                </>
              ) : null}
            </Col>
            <Col span={6}>
              {props.phone || props.fax || props.website ? (
                <Row className={`${styles.paddedBottom} ${styles.nonMargin}`}>
                  {props.phone ? (
                    <Col span={4}>
                      <p className={styles.title}>Phone</p>
                      <p className={styles.body}>{props.phone}</p>
                    </Col>
                  ) : null}
                  {props.fax ? (
                    <Col span={4}>
                      <p className={styles.title}>Fax</p>
                      <p className={styles.body}>{props.fax}</p>
                    </Col>
                  ) : null}
                  {props.website ? (
                    <Col span={8}>
                      <p className={styles.title}>Web</p>
                      {Array.isArray(props.website) ? props.website.map((e) => renderWeb(e)) : renderWeb(props.website)}
                    </Col>
                  ) : null}
                </Row>
              ) : null}
              {props.email ? (
                <Row>
                  <Col span={12}>
                    <p className={styles.title}>Email</p>
                    {Array.isArray(props.email) ? props.email.map((e) => renderEmail(e)) : renderEmail(props.email)}
                  </Col>
                </Row>
              ) : null}
            </Col>
          </Row>
        </ContentContainer>
      </div>
    </div>
  );
};

export default ContactUsInfo;
